import { jsx as _jsx } from "react/jsx-runtime";
import { SingleSelect, } from 'react-select-material-ui';
import { theme } from '../../themes/theme';
const customStyles = {
    menuPortal: (base) => (Object.assign(Object.assign({}, base), { zIndex: 9999 })),
    clearIndicator: (provided) => (Object.assign(Object.assign({}, provided), { color: theme.palette.grey[400], '&:hover': {
            color: theme.palette.grey[600],
        } })),
};
//TODO Add to storybook
const SelectUncontrolled = (props) => {
    var _a;
    return (_jsx(SingleSelect, { margin: (_a = props.margin) !== null && _a !== void 0 ? _a : 'dense', name: props.name, onChange: props.onChange, options: props.options, label: props.label, helperText: props.helperText, value: props.value, disabled: props.disabled, SelectProps: {
            styles: Object.assign({}, customStyles),
            msgNoOptionsAvailable: props.noOptionsMessage,
            isLoading: props.isLoading,
            autoFocus: props.autoFocus,
            onInputChange: props.onInputChange,
            isClearable: props.isClearable,
            menuPortalTarget: document.body,
            onKeyDown: (event) => {
                //stopPropagation fixes handling ot ESC in select inside modal
                //ESC should close select dropdown menu and not the whole modal
                event.stopPropagation();
                if (props.onKeyDown) {
                    props.onKeyDown(event);
                }
            },
        } }));
};
export default SelectUncontrolled;
